import {createSelector} from 'reselect';
import {getListingAvailability} from './store';
import {getRateSummary} from './listing';

const getShouldShowRates = createSelector(
    [getRateSummary],
    (rateSummary) => {
        const hasRates =
            rateSummary &&
            rateSummary.rentNightsConverted &&
            rateSummary.rentNightsConverted.length;

        // We only legally show rates in the calendar for US brands
        const hasUSCurrency = rateSummary && rateSummary.travelerCurrency === 'USD';
        const hasAccurateRate = rateSummary && rateSummary.accurateRate;

        // These could be undefined, which leads to this selector returning undefined instead of a truethy value.
        return !!hasRates && !!hasAccurateRate && !!hasUSCurrency;
    }
);

// Dateless won't change after calculated. This selector prevents unnecessary re-rendering when availability changes
const getDatelessAvailability = createSelector(
    [getListingAvailability],
    (listingAvailability) => listingAvailability.dateless
);

const getCheckinAvailability = createSelector(
    [getListingAvailability],
    (listingAvailability) => listingAvailability.checkin
);

const getCheckoutAvailability = createSelector(
    [getListingAvailability],
    (listingAvailability) => listingAvailability.checkout
);

const getDatelessAvailabilityData = createSelector(
    [getDatelessAvailability],
    (dateless) => dateless
);

const getDatePickerAvailabilityData = createSelector(
    [getCheckinAvailability, getCheckoutAvailability],
    (checkin, checkout) => ({checkin, checkout})
);

export default getDatePickerAvailabilityData;
export {getDatePickerAvailabilityData, getDatelessAvailabilityData, getShouldShowRates};
